import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdateInventoryMeterArgs } from 'lib/services/inventories/metersApi';
import { useMutation, useQueryClient } from 'react-query';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useUpdateInventoryMeter = () => {
  const appNotification = useAppNotifications();
  const queryClient = useQueryClient();
  const { inventoryMetersApiClient } = useServices();

  return useMutation({
    mutationFn: async (args: UpdateInventoryMeterArgs) => await inventoryMetersApiClient.update(args),
    mutationKey: MUTATION_KEYS.inventoryMeters.updateOne(),
    onSuccess() {
      queryClient.invalidateQueries(QUERY_KEYS.inventoryMeters.all());
      appNotification.success({
        message: `Inventory meter was updated successfully`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.inventoryMeters.all());
    },
    onError(err: Error) {
      appNotification.error({
        message: `There was an error: ${err.name}`,
      });
    },
  });
};
